import React, { Component } from 'react';
import { getAccInfo, setUnbind, rechargeBalance, } from './service'
import { getCampusPay } from '../cardBinding/service'
import { Toast, Form, Input, Button, Modal, Dialog, Space, SpinLoading } from 'antd-mobile'
import MD5 from '../../common/md5'
import {debounce} from '../../utils/util'
import './index.scss';
class CardRechargeInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalVisible: false,
      projectId: null,
      userInformation: {},
      organizationName: null,
      rechargeStatus: false,
      rechargeMoney: null,
      userId: null,
      payWay: null,
      telPhone: null,
      loginCode: null,
      isLoading: true,
      phoneSystem: null,
    }
    this.onSubmit = debounce(this.onSubmit, 1000)

  }
  componentDidMount() {
    document.title=""
    let search = window.location.search.slice(1)
    let params = search.split('&')
    var theRequest = new Object()
    for (let i = 0; i < params.length; i++) {
      theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
    }
    const script = document.createElement('script');
    script.src = 'https://appx/web-view.min.js';
    document.head.appendChild(script);
    this.setState({
      projectId: theRequest.projectId,
      rechargeMoney: theRequest.rechargeMoney,
      organizationName: theRequest.organizationName,
      payWay: theRequest.payWay,
      telPhone: theRequest.telPhone,
      userId: theRequest.userId,
      loginCode: theRequest.loginCode,
      accountId: theRequest.accountId,
      phoneSystem: theRequest.phoneSystem,
    }, () => {
      this.getCampusPayVerify()
    })
  }
  getCampusPayVerify = () => {
    let params = {
      projectId: this.state.projectId,
      userId: this.state.userId,
      loginCode: this.state.loginCode,
      accountId: this.state.accountId,
    }
    if (this.state.phoneSystem) {
      params.phoneSystem = this.state.phoneSystem;
    }
    getCampusPay(params).then(res => {
      if (res.errorCode === 0) {
        this.setState({
          organizationName: res.data.organizationName
        })
        document.title = res.data.organizationName + '充值'
        if (window && window?.my) {
          window.my.postMessage({'sendToMiniProgram': document.title});
        }
        this.getAccountInfo()

      }else{
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
        this.setState({
          isLoading: false
        })
      }
    })
  }
  getAccountInfo = () => {
    let { userId, projectId, rechargeMoney, organizationName, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
    let params = {
      projectId: projectId,
      userId: userId,
      loginCode: loginCode,
      accountId: accountId,
    }
    if (phoneSystem) {
      params.phoneSystem = phoneSystem;
    }
    getAccInfo(params).then(res => {
      if (res.errorCode === 0) {
        this.setState({
          userInformation: res.data,
          isLoading: false
        })
      } else if (res.errorCode === 65) {
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
        setTimeout(() => {
          this.props.history.push('/cardBinding?rechargeMoney='
            + rechargeMoney + '&userId=' + userId +
            '&projectId=' + projectId + '&organizationName=' + organizationName + '&telPhone=' + telPhone
            + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
        }, 1000);
      } else {
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
        this.setState({
          isLoading: false
        })
      }
    })
  }
  onChangeCardUnbind = () => {
    let { userId, projectId, rechargeMoney, organizationName, telPhone, loginCode, payWay, accountId, phoneSystem } = this.state
    let params = {
      userId,
      projectId,
      loginCode,
      accountId
    }
    if (phoneSystem) {
      params.phoneSystem = phoneSystem;
    }
    setUnbind(params).then(res => {
      if (res.errorCode === 0) {
        Toast.show({
          content: '解绑成功！',
          position: 'bottom',
        })
        setTimeout(() => {
          this.props.history.push('/cardBinding?rechargeMoney='
            + rechargeMoney + '&userId=' + userId +
            '&projectId=' + projectId + '&organizationName=' + organizationName + '&telPhone=' + telPhone
            + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
        }, 1000);
      } else {
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
      }
    })
  }
   /**
     * 充值
     */
     onSubmit = () => {
       this.setState({
        isLoading:true
       })
      let { organizationName, telPhone, payWay, rechargeMoney, accountId, loginCode, projectId, userId, phoneSystem } = this.state
      let signature = 'loginCode' + loginCode + 'payWay' + payWay +
        'rechargeMoney' + rechargeMoney + 'telPhone' + telPhone + 'sign-kailu='
      console.log('signature', signature)
      signature = MD5.md5(signature).toLowerCase()
      let params = {
        telPhone,
        payWay,
        projectId,
        signature,
        rechargeMoney,
        accountId,
        loginCode,
        userId
      }
      if (phoneSystem) {
        params.phoneSystem = phoneSystem;
      }
      rechargeBalance(params).then(res => {
        if (res.errorCode === 0) {
          this.setState({
            isLoading:false
           })
          Toast.show({
            content: '充值成功！',
            position: 'bottom',
          })
          setTimeout(() => {
            this.props.history.push('/walletSuccessPage?organizationName=' + organizationName)
          }, 1000);
        } else if (res.errorCode === 145) {
          Toast.show({
            content: res.errorMessage,
            position: 'bottom',
          })
          this.setState({
            isLoading:false
           })
          setTimeout(() => {
            this.props.history.push('/cardBinding?rechargeMoney='
              + rechargeMoney + '&userId=' + userId +
              '&projectId=' + projectId + '&organizationName=' + organizationName + '&telPhone=' + telPhone
              + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId + '&phoneSystem=' + phoneSystem)
          }, 1000);
        } else {
          this.setState({
            isLoading:false
           })
          Toast.show({
            content: res.errorMessage,
            position: 'bottom',
          })
        }
      })
    }
  render() {
    const { userInformation, organizationName, rechargeMoney, } = this.state
    //解绑
    const unbind = () => {
      Dialog.confirm({
        title: "提示",
        content: '是否解绑当前绑定账号',
        onConfirm: async () => {
          await this.onChangeCardUnbind()
          return true
        },
      })
    }
    return (
      <>
        {!this.state.isLoading ? <div className="card-recharge-info-page">
          <Form layout='horizontal'
            key={userInformation.balance}
            onFinish={this.onSubmit}
            footer={
              <Button block color='primary' type='submit' size='large'>
                确定
                    </Button>
            }
          >
            <div className="user-Unbinding">
              <div className="user-Unbinding-label">{organizationName}账户:</div>
              <Button color='primary' onClick={() => { unbind() }} fill='none'>解绑</Button>
            </div>
            <Form.Item label='账户信息:' name='campusUser' className="user-information" >
              <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.campusUser || ''} placeholder='' clearable />
            </Form.Item>
            <Form.Item label='账户状态:' name='status' className="user-status" >
              <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.status || '--'} placeholder='' clearable />
            </Form.Item>
            <Form.Item label='账户金额:' name='balance' className="user-money" >
              <Input readOnly style={{ '--text-align': 'right' }} defaultValue={userInformation.balance ? (userInformation.balance / 100).toFixed(2) + '元' : '--'} placeholder='请输入' clearable />
            </Form.Item>
          </Form>
          <div className="card-recharge-btn">
            <div className="user-Unbinding-label">充值金额:</div>
            <Input key={rechargeMoney} readOnly style={{ '--text-align': 'right' }} placeholder='' defaultValue={(rechargeMoney || '0') + '元'} clearable />
          </div>
        </div>
          :
          <div className="page-loading">
            <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
              <SpinLoading color='primary' />
            </Space>
          </div>

        }
      </>
    );
  }

}

export default CardRechargeInfo;
